import { Grid, styled, Typography } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledValueFormHeader = styled(Typography)`
  background: ${colors.primary15};
  color: ${colors.primary900};
  height: 48px;
  font-size: 20px;
  border-radius: 4px;
  padding: 12px 20px;
  margin-left: -5px;
  margin-top: 8px;
`;
export const StyledValueDetailsHeader = styled(Typography)`
  background: ${colors.primary900};
  color: ${colors.white};
  height: 48px;
  font-size: 20px;
  border-radius: 4px;
  padding: 12px 20px;
  margin-left: -5px;
  margin-top: 8px;
`;
export const StyledValueDetails = styled(Grid)`
  border: 1px solid ${colors.gray200};
  background: ${colors.gray100};
  row-gap: 10px;
  border-radius: 4px;
  border-width: 1px;
  padding: 20px;
  margin-left: -5px;
`;
